import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, lastValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';
import { ROLE_WORKSPACE_USER } from 'src/app/app.models';

@Injectable({
    providedIn: 'root'
})
export class FENoAuthGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _authService: AuthService
    ) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const authSessionDto = this._authService.authenticatedSession$.value!;
        if (this._authService.isAuthenticated && !!authSessionDto) {
            if (authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.USER_WORKSPACE) { 
                this._router.navigate(['/apps/cashdesk/main']); 
                return false; 
            } else { 
                this._authService.doUnlockSession();
                await lastValueFrom(this._authService.doRemoveAuthSession()); 
            }
        }

        return true;
    }
}
